import React, { useEffect } from "react";

// Components imports
import Button from "../Button";

import { useHistory } from "react-router-dom";

// Scss imports
import css from "./PopUp.module.scss";

// import { connect } from 'react-redux'
import { useDispatch } from "react-redux";
import {
  resetPaperStore,
  getRecipientAndSenders
} from "../../../redux/actions/papersActions";

interface PopUpProps {
  location?: any;
  setPopupShown: Function;
  clearInputFields?: any;
  setSubnumber?: any;
}
const PopUp: React.FC<PopUpProps> = ({
  location,
  setPopupShown,
  clearInputFields,
  setSubnumber
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    dispatch(resetPaperStore());
  }, []);

  return (
    <div id="popup" className={css.overlay}>
      <div className={css.popup}>
        <h2>Креирај нови документ</h2>
        <div className={css.buttonsContainer}>
          <div className={css.textButtonContainer}>
            <Button
              text="Да"
              onButtonClickHandler={() => {
                dispatch(resetPaperStore());
                setPopupShown(false);
                clearInputFields();
                dispatch(getRecipientAndSenders());
                setSubnumber("");
                //window.location.reload();
              }}
              type="fixed"
            />
            <p>Креирај нови документ</p>
          </div>
          <div className={css.textButtonContainer}>
            <Button
              text="Не"
              onButtonClickHandler={() => {
                dispatch(resetPaperStore());
                setPopupShown(false);
                history.push("/");
              }}
              type="fixed"
            />
            <p>Иди на главну страну</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopUp;
